module.exports = __webpack_public_path__ + "static/media/Shaolinyinyanglogo2012.27993762.webp";